export default __webpack_public_path__ + "static/media/H_wdt_c_cap_3.0764f8ec.mp3";